import React, {
  useState,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Container,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import Page from '../../../../components/Layout/Page';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import UserEditForm from './UserEditForm';
import CategoryUserRolesForm from './CategoryUserRolesForm';
import Header from './Header';

import useStyles from './styles';
import alphabeticSort from '../../../../utils/alphabeticSort';

import { getUserDetail } from '../../../../requests/api/users';

import { getAllSupermarkets } from '../../../../requests/api/supermarkets';
import { getAllCategories } from '../../../../requests/api/categories';

function AdminEditView(props) {
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [user, setUser] = useState();
  const [supermarkets, setSupermarkets] = useState([]);
  const [categories, setCategories] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const getUser = async () => {
      const res = await getUserDetail(props.match.params.id);
      const response = res.data;
      if (isMountedRef.current) {
        setUser(response.data);
      }
    };

    getUser();
  }, [props]);

  useEffect(() => {
    try {
      const getSupermarkets = async () => {
        const response = await getAllSupermarkets();
        if (response.success) {
          const data = await response?.data?.data;
          setSupermarkets(data.sort((a, b) => alphabeticSort(a, b)));
        } else {
          enqueueSnackbar('Error al cargar la información de las categorías.', {
            variant: 'error',
          });
        }
      };
      getSupermarkets();
    } catch {
      setSupermarkets([]);
    }
  }, []);

  useEffect(() => {
    try {
      const getCategories = async () => {
        const response = await getAllCategories();
        if (response.success) {
          const data = await response?.data?.data;
          setCategories(data.sort((a, b) => alphabeticSort(a, b)));
        } else {
          enqueueSnackbar('Error al cargar la información de las categorías.', {
            variant: 'error',
          });
        }
      };
      getCategories();
    } catch {
      setCategories([]);
    }
  }, []);

  if (!user) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="FH Engel | Editar Usuario"
    >
      <Container maxWidth="lg">
        <Header />
        <Box mt={3}>
          <UserEditForm user={user} />
          {user.role === 'external' ? (
            <CategoryUserRolesForm
              user={user}
              supermarkets={supermarkets}
              categories={categories}
            />
          ) : (<Box></Box>)}
        </Box>
      </Container>
    </Page>
  );
}

AdminEditView.propTypes = {
  match: PropTypes.any,
};

export default withRouter(AdminEditView);
